export default "__VITE_ASSET__CElzDnJf__"